module.exports = __webpack_public_path__ + "static/media/scope_markets_logo.062c14fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scope_markets_logo.svg
// module id = 1147
// module chunks = 0